import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { OverviewImmoTask } from '../model/overview-immo-task';
import { Observable } from 'rxjs';
import {
  DeserializeVoid,
  _get,
  _post,
} from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ImmoTaskOverviewControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializeOverviewImmoTask = (res) => {
    const result: ProperPageResult<OverviewImmoTask> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;

    return result;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/immotask', requestServices);
    this.post = _post('/immotask', requestServices);
  }

  public getTable(
    filters: string,
    sort: string,
    sortAscending: boolean,
    pageSize: number,
    page: number,
    showArchived: boolean
  ): Promise<ProperPageResult<OverviewImmoTask>> {
    const filtersParam: string = `filters=${filters}`;
    const pageableParam: string = `page=${page}&size=${pageSize}&sortDirection=${
      sortAscending ? 'ASC' : 'DESC'
    }&sortProperty=${sort}`;
    const showArchivedParam: string = `showArchived=${showArchived}`;
    const pathParams: string = `?${filtersParam}&${pageableParam}&${showArchivedParam}`;

    return this.get(
      `/table${pathParams}`,
      this.deserializeOverviewImmoTask
    ).toPromise();
  }

  public archive(id: number): Promise<void> {
    return this.post(`/archive/${id}`, null, DeserializeVoid).toPromise();
  }
}
